import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import type { OffRampType } from '../../../../types/prequal-questionnaire';

import conf from '../../conf';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { exitQuestionnaire } from '../../lib/side-effects/prequal-questionnaire';
import { selectState } from '../../selectors';
import { getCtaUrlWithCampaignId } from '../helpers/prequal-questionnaire';

const OffRampContainer = styled.div`
  s-row {
    flex-wrap: nowrap
  }

  img {
    max-height: 280px;
    max-width: 450px;
  }
`;

type Props = {
  pageData: OffRampType;
};

const PrequalOffRampPage = ({ pageData: { content, id } }: Props) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    questionnaire: { config },
  } = useSelector(selectState);
  const campaignId = config?.campaignId || '';
  const ctaUrl = getCtaUrlWithCampaignId(campaignId, content.actionButtonUrl);

  return (
    <OffRampContainer className='margin-top-xl'>
      <SRow className='flex flex-dir-row margin-top-xl'>
        <SCol span='sm-12 6'>
          <SRow>
            <h1 data-ref='buy.prequal.offramp-page.header'>{content.heading}</h1>
          </SRow>
          <SRow>
            <p data-ref='buy.prequal.offramp-page.body' className='margin-top-lg'>
              {content.body}
            </p>
          </SRow>
          <SRow>
            <p data-ref='buy.prequal.offramp-page.call-to-action' className='margin-top-lg margin-bottom-lg text-md'>
              {content.callToAction}
            </p>
          </SRow>
          <SRow className='flex align-items-center margin-top-lg'>
            <button
              type='button'
              className='secondary active margin-right-sm'
              data-ref='qualification.offRampPage.backButton'
              onClick={() => history.goBack()}
            >
              {t('client.buttons.back')}
            </button>
            <button
              type='button'
              className='primary large text-sm'
              data-ref='qualification.offRampPage.actionLink'
              onClick={() => dispatch(exitQuestionnaire(ctaUrl, id))}
            >
              {content.actionButtonText}
            </button>
          </SRow>
        </SCol>
        <SCol span='sm-hide 6' className='margin-top-xl'>
          <img
            alt=''
            src={`${conf.ASSET_PATH}/assets/images/prequal/${content.imageFile}`}
            style={{ maxWidth: '350px' }}
          />
        </SCol>
      </SRow>
    </OffRampContainer>
  );
};

export default PrequalOffRampPage;
